import React from 'react'

const Header = () => {
  return (
    <h1>Guess the language</h1>
  )
}

export default Header